import React, { useState, useRef, useEffect } from 'react';
import { Tabs, Tab, Row, Col, Container } from 'react-bootstrap';
import { Alert, Drawer } from 'antd';

import Navbar from '../Navbar/NavBar';
import EntitiesBodyWrapper from '../../components/Entities/EntitiesBodyWrapper';
import 'antd/dist/antd.css';
import './Entities.scss';
import { useEntitiesDispatch, useEntitiesState } from 'store/hooks/entities';
import { useRouter } from 'helpers/customHooks';
import { Entity } from './types';

const Entities = () => {
  const { history } = useRouter();
  const { byTeam } = useEntitiesState();
  const {
    getEntities: loadEntities,
    handleOnByTeamToggle,
    cleanEntitiesState
  } = useEntitiesDispatch();
  const [currentAlerts, setCurrentAlerts] = useState<JSX.Element[]>([]);
  const [drawerVisible, setDrawerVisible] = useState<boolean | undefined>(undefined);

  const alertCount = useRef<number|null>(null);

  useEffect(() => {
    return () => {
      cleanEntitiesState();
    };
  }, []);

  const onAlertClose = () => {
    alertCount.current = alertCount.current && alertCount.current - 1;
    if (alertCount.current === 0) {
      setDrawerVisible(false);
    }
  };
  const onDrawerClose = () => {
    setDrawerVisible(false);
    setCurrentAlerts([]);
  };

  const onOpenAlertsClick = () => {
    setDrawerVisible(true);
  };

  const computeRepeatedTags = (entities : Entity[]) => {
    const tagMap = new Map();

    for (const entity of entities) {
      if (entity && entity.tags && entity.tags.length > 0) {
        for (const tag of entity.tags) {
          if (tagMap.has(String(tag.id))) { // add new name to array of existing names using that tag
            tagMap.set(String(tag.id), [...tagMap.get(String(tag.id)), entity.name]);
          } else { // insert a new key into map, value is new Array containing entities name.
            tagMap.set(String(tag.id), new Array(entity.name));
          }
        }
      }
    }

    const alerts = [];

    for (const [key, value] of tagMap) {
      if (value.length > 1) {
        if (value.length === 2) { // duplicates
          alerts.push(
            <Alert
              key={key}
              message={`Duplicate Tags Found ${key}`}
              description={`Duplicate Tag found for Entity: ${value[0]} and ${value[1]}`}
              type="warning"
              closable
              onClose={() => onAlertClose()}
            />
          );
        } else { // more than two repetitions
          alerts.push(
            <Alert
              key={key}
              message={`Tag ${key} was repeated multiple times`}
              description={`Tag is being used more than 2 times`}
              type="warning"
              closable
              onClose={() => onAlertClose()}
            />
          );
        }
      }
    }

    tagMap.clear();
    if (currentAlerts.length === 0) {
      setCurrentAlerts(alerts);
      alertCount.current = alerts.length;
    }
  };

  const handleByTeamCheck = () =>{
    handleOnByTeamToggle(!byTeam); // must be first
    loadEntities();
  };

  return (<>
    <Navbar/>
    <Container className="container-00">
      <Row>
        <Col lg={12} xs={12}>
          <div className="profiles-pp">
            <h4 style={{width:'200px'}}>Entities</h4>
            <div className="byTeam-00">
              <label className="l-c">
                <input
                  className="styled-checkbox"
                  id="styled-checkbox-2"
                  type="checkbox"
                  checked={!!byTeam}
                  onChange={handleByTeamCheck}
                />
                <label htmlFor="styled-checkbox-2" className="check-l" />
              </label>
              <b>By Team</b>
            </div>
            <button className="btn-blue open-tag" onClick={() => onOpenAlertsClick()}>
              Open Alerts
            </button>
          </div>
          <Tabs defaultActiveKey="noc" id="uncontrolled-tab-example" mountOnEnter unmountOnExit onSelect={(e) => {
            history.push({pathname: '/entities/' + e});
          }}>
            <Tab eventKey="noc" title="NOC">
              <EntitiesBodyWrapper
                isToday={false}
                computeRepeatedTags={computeRepeatedTags}
                drawerVisible={drawerVisible}
                setDrawerVisible={setDrawerVisible}
                alertCount={alertCount}
              />
            </Tab>
            {/*<Tab eventKey="venues" title="Venues" path="/Venues">
              <EntitiesBody/>
            </Tab>*/}
          </Tabs>

          {currentAlerts.length > 0 &&
            <Drawer
              title={`Duplicate Tags, ${currentAlerts.length} alerts`}
              placement="right"
              maskClosable
              onClose={onDrawerClose}
              visible={drawerVisible}
              className="drawer-entities"
              width="350px"
            >
              {currentAlerts}
            </Drawer>
          }
        </Col>
      </Row>
    </Container>
  </>);
};
export default Entities;
